<template>
  <back-section :menu="nama" />
  <list-data-izin-setuju />
</template>
<script>
import ListDataIzinSetuju from "@/components/ListDataIzinSetuju.vue";
import BackSection from "@/components/BackSection.vue";
export default {
  setup() {
    return {
      nama: "List Izin Disetujui",
    };
  },
  components: { ListDataIzinSetuju, BackSection },
};
</script>
